import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { PreferenzeUtente } from 'src/app/main/_models/utente';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	preferences() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/preferences`);
	}

	activate(token: string) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/activate`, { token });
	}

	forgotPassword(username: string) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/forgotPassword`, { username });
	}

	current() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/current`);
	}

	get(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/` + id);
	}

	update(user: any) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users`, user);
	}

	insert(user: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users`, user);
	}

	delete(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/${id}`);
	}

	register(user: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/register`, { user });
	}

	storePreferences(p: PreferenzeUtente) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/preferences`, p);
	}

	datatable(data: any) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/users/dt`, data);
	}

	check_wizard_complete() {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/wizard/complete`, {});
	}

}

